// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2KmgJ","errors":"Errors_errors__1ZU3m"};